import type { FormEvent } from 'react'
import { type LoaderFunctionArgs, useLoaderData, Form, useParams } from 'react-router-dom'

import type { IWebsite } from '@glocal/schemas'

import * as Checkbox from '@radix-ui/react-checkbox'
import * as Label from '@radix-ui/react-label'

import { IconCheck } from '../components/icon-check'
import { IconTrash } from '../components/icon-trash'
import { trpc } from '../trpc'

export async function loader({ params }: LoaderFunctionArgs) {
	const { websiteID } = params
	if (!websiteID) {
		throw new Error('400 Bad Request')
	}

	const website = await trpc().WebsiteService.Get.query(websiteID)
	if (!website) {
		throw new Error('404 Not Found')
	}

	return { website }
}

export function WebsiteEdit() {
	const { accountID } = useParams()
	const { website } = useLoaderData() as { website: IWebsite }

	function onDelete(e: FormEvent<HTMLFormElement>) {
		if (!confirm(`Сonfirm website deletion`)) {
			e.preventDefault()
		}
	}

	return (
		<div className="p-4 flex flex-col gap-4 w-full max-w-sm">
			<div className="mb-4 flex justify-between">
				<h1 className="text-4xl truncate">{website.name}</h1>
			</div>

			<Form
				action={`/account/${accountID!}/website/${website.id}/edit`}
				method="post"
				className="flex flex-col gap-4"
			>
				<div className="mt-2 flex items-center">
					<Checkbox.Root
						id="website-banner"
						className="check"
						name="banner"
					>
						<Checkbox.Indicator className="text-violet11">
							<IconCheck size={20} />
						</Checkbox.Indicator>
					</Checkbox.Root>
					<Label.Root
						className="px-4 flex items-baseline"
						htmlFor="website-banner"
					>
						<span className="font-medium text-sm">Place a banner</span>
					</Label.Root>
				</div>
			</Form>

			<hr />

			<Form
				action={`/account/${accountID!}/website/${website.id}/destroy`}
				method="post"
				className="flex flex-col gap-4"
				onSubmit={onDelete}
			>
				<button
					className="btn btn-danger"
					type="submit"
				>
					<IconTrash />
					<span className="font-semibold">Destroy Website</span>
				</button>
			</Form>
		</div>
	)
}
